import { createFileRoute } from "@tanstack/react-router";
import { CertificatesView } from "@/features/ksef/certificates-view";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/ksef-certyfikaty")({
	component: CertificatesView,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.system.ksef-certyfikaty",
			location.pathname,
		);
	},
});
